export default function PriceDisplay({ mrp, price, discount }) {
  return (
    <div className="price-row">
      <span className="price">₹{price}</span>
      {mrp > price && <span className="mrp">₹{mrp}</span>}
      {discount > 0 && <span className="badge discount">{discount}% OFF</span>}
    </div>
  );
}
